import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { isLoggedIn, hasAuthCheckFinished } from '../auth/reducer.js'
import { Container, PageSpinner, H1, Button } from '../components/index.js'
import { loginUser } from '../auth/actions.js'

const mapProps = state => ({
  isLoggedIn: isLoggedIn(state),
  loginFinished: hasAuthCheckFinished(state)
})

const LoginRequired = withRouter(connect(mapProps, { loginUser })(({ isLoggedIn, loginFinished, title, loginUser, children }) => {
  if (!loginFinished) return <PageSpinner title={title} noHeader />
  if (!isLoggedIn) {
    return (
      <Container fluid>
        <H1 className='u-sm-ib u-va-m'>You must be logged in to view this page</H1>
        <Button extraClassName='m2-sm u-sm-ib u-va-m' onClick={loginUser}>Login</Button>
      </Container>
    )
  }

  return React.Children.only(children)
}))

const requireLogin = (title) => (WrappedComponent) => (props) => (
  <LoginRequired title={title}>
    <WrappedComponent {...props} />
  </LoginRequired>
)

export { LoginRequired }
export default requireLogin



// WEBPACK FOOTER //
// ./client/src/auth/requireLogin.js